/* remate ajustes-1-3-0, R2 (#509, 25-sep-2026): LA FECHA DEL HISTORIAL EN EL IDIOMA DEL ALUMNO.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Hasta hoy `StudyLog.js` formateaba `started_at` con `toLocaleDateString('en-US')` +
   ' at ' + `toLocaleTimeString('en-US')`, tambien en espanol ("9/25/2026 at 6:55 PM"). La hora
   ya era la LOCAL del navegador (el servidor guarda `+00:00`): eso no cambia. Lo que cambia es el
   idioma y la forma: `Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' })`
   sobre el instante guardado, sin literal " at " ni "a las". En espanol "25 sept 2026, 18:55",
   en ingles "Sep 25, 2026, 6:55 PM". Nota medida: la abreviatura de es-MX es "sep" (la de
   es-ES seria "sept"); se respeta el locale del alumno.

   El locale de FORMATO sale del idioma de i18n (el mismo que decide todos los textos):
   `es` -> `es-MX`, `en` -> `en-US`. El repo no tenia un helper de locale de fecha para el alumno
   (`lib/dateFormat.js` es del panel de administracion, fijo en en-US y hora de Mexico;
   `fechaDeCaducidad.js` recibe el idioma crudo), asi que nace aqui, en un solo sitio.

   `opciones.timeZone` existe SOLO para las pruebas (jsdom no deja cambiar TZ en caliente): en
   produccion no se pasa y manda la zona del aparato, como antes. */

const LOCALE_DE_FORMATO = { es: 'es-MX', en: 'en-US' };

/** El locale de formato que corresponde al idioma de i18n ('es-419' -> es-MX; desconocido -> en-US). */
export function localeDeFecha(idioma) {
  const base = String(idioma || '').toLowerCase().split('-')[0];
  return LOCALE_DE_FORMATO[base] || LOCALE_DE_FORMATO.en;
}

const formateadores = new Map();

function formateador(locale, timeZone) {
  const llave = locale + '|' + (timeZone || '');
  if (!formateadores.has(llave)) {
    // En espanol la hora va en 24 horas ("18:55"), como pide el encargo; es-MX por si solo
    // daria "6:55 p.m.". En ingles, el ciclo del locale ("6:55 PM").
    formateadores.set(llave, new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium', timeStyle: 'short',
      ...(locale === LOCALE_DE_FORMATO.es ? { hourCycle: 'h23' } : {}),
      ...(timeZone ? { timeZone } : {}),
    }));
  }
  return formateadores.get(llave);
}

/**
 * "25 sept 2026, 18:55" / "Sep 25, 2026, 6:55 PM" a partir del instante ISO guardado
 * (`started_at`, con `+00:00`), en la hora local del aparato. '-' si no hay fecha o no se
 * puede leer.
 */
export function formatearFechaDeSesion(iso, idioma, opciones = {}) {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  try {
    return formateador(localeDeFecha(idioma), opciones.timeZone).format(d);
  } catch (e) {
    return '-';
  }
}

export default formatearFechaDeSesion;
